export default __webpack_public_path__ + "static/bipublisher-f08e7959e1b6a2a32529b588fdf20d1d.svg";